import './index.scss';
import { useCallback, useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { HiOutlineLogout } from 'react-icons/hi';
import { IMenu, MenuProps } from '../types';
import { getCurrentPage } from 'src/utils/helpers';
import { AppLabel, FlexColumn } from "src/style";
import { useMenuList } from 'src/hooks';
import VisibilityContext from 'src/provider/state-manager/visibilityProvider';
import UserContext from 'src/provider/state-manager/userProvider';

export const MobileMenu = ({ memberType, handleModal }: MenuProps) => {
    const navigate = useNavigate();
    const [selected, setSelected] = useState<string | undefined>(getCurrentPage());
    const { menu } = useMenuList();
    const { visibility, setModal } = useContext(VisibilityContext);
    const { user: { profile } } = useContext(UserContext)

    useEffect(() => {
        setSelected(getCurrentPage())
    }, [getCurrentPage()]);

    const handleSelect = (item: IMenu) => {
        if (item.link === "view-results") {
            setModal({ key: "showViewResults", value: !visibility.showViewResults })
        } else if (item.link === "profile") {
            if (profile.memberType === 'Student') navigate('/dashboard/profile')
            else setModal({ key: "showUserProfileModal", value: !visibility.showUserProfileModal })
        }

        else if (item.link === "broadcast-mail") {
            setModal({ key: "broadCastMail", value: !visibility.broadCastMail });
        } else if (item.link === "reset-password") {
            setModal({ key: "resetPassword", value: !visibility.resetPassword });
        } else {
            navigate(`/dashboard/${item.link}`)
        }
    }

    const renderMenu = useCallback((menu: IMenu[]) => menu?.map(item => {
        if (item.screen.includes(memberType)) {
            return (
                <FlexColumn
                    gap='.5'
                    width='100%'
                    key={item.label}
                    topPadding='1'
                    bottomPadding='1'
                    leftPadding='1.5'
                    rightPadding='1.5'
                    bgColor={item.link === selected ? '#702126' : ''}
                    onClick={() => handleSelect(item)}
                    className={item.link === selected ? 'flex-menu selected' : 'flex-menu menu-item'}
                >
                    {item.logo}
                    <AppLabel
                        textSize='1.5'
                        bottomMargin='0'
                        fontWeight='400'
                        color={item.link === selected ? '#fff' : '#702126'}
                    >
                        {item.label}
                    </AppLabel>
                </FlexColumn>
            )
        }
    }), [selected, memberType])

    return (
        <div className='bottom-menu'>
            {renderMenu(menu)}
            <FlexColumn
                gap='.5'
                width='100%'
                topPadding='1'
                bottomPadding='1'
                leftPadding='1.5'
                rightPadding='1.5'
                className={'flex-menu menu-item'}
                onClick={handleModal}
            >
                <HiOutlineLogout size={22} />
                <AppLabel
                    textSize='1.5'
                    bottomMargin='0'
                    fontWeight='400'
                    color={'#702126'}
                >

                    Logout
                </AppLabel>
            </FlexColumn>
        </div>
    )
}
